import { callFirebaseHttpFunction } from "../callFirebaseHttpFunction"

export const getCruiseList = async (tripId: string, tripSearchId: string) => {
  try {
    const result = await callFirebaseHttpFunction({
      name: "publicGetCruiseList",
      payload: { tripId, tripSearchId },
    })

    return result.data?.result
  } catch (error) {
    console.error("error getting cruise list", { error })
    return {
      tripSearchResults: [],
      cruiseSearchPreferences: null,
      tripInviteLink: "https://cruisen.app.link/get",
      tripName: "All cruises",
    }
  }
}
